import { Serializable } from "../utilities/Serializable";

export class Zone extends Serializable {
    uuid: string;
    name: string;
}


// WEBPACK FOOTER //
// ./src/app/models/Zone.ts